import { useCabinBooking } from "../../../Hooks/Features/CabinBooking/useCabinBooking";
import { Dialog } from 'primereact/dialog';
import CabinBookingForm from "../../../components/CabinBooking/CabinBookingForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CabinBookingCalendar from "../../../components/CabinBooking/CabinBookingCalendar";
import { SkeletonCabinCard } from "../../../components/Loader/Loader";
import { useCommon } from "../../../Hooks/Common/useCommon";

const CabinBooking = () => {

    const { checkPermission } = useCommon();
    const { cabinList, showBooking, setShowBooking, bookCabinInfo, view, setView, shiftTime, getCabinBookingDetails, callApi, setCallApi, getCabinList, cabinData, handleBookNow, displaySlot, loader, tagRef } = useCabinBooking();

    return (
        <div className="p-2" ref={() => checkPermission("Cabin", tagRef)}>
            <div ref={tagRef} id='{"tabname": "cabin", "data": "cabin_li"}'>
                <div className="mb-3 d-flex justify-content-between align-items-center">
                    <h5>{view === "card" ? "Cabin Booking by Floor" : "Cabin Booking Calendar"}</h5>
                    <div className="d-flex">
                        <button className="button btn-default" onClick={() => { view === "card" ? getCabinList() : setCallApi(!callApi) }} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                        <button className="button btn-default" onClick={() => setView(view === "card" ? "calendar" : "card")} title={view === "card" ? "Calendar View" : "Card View"}>
                            <FontAwesomeIcon icon={`fa-solid ${view === "card" ? "fa-calendar" : "fa-table"}`} />
                        </button>
                    </div>
                </div>
                {view === "card" ?
                    <div>
                        {loader?.cabin || loader?.history ?
                            <div className="row"><SkeletonCabinCard numSkeletons={10} height="120px" /></div> :
                            (cabinList?.map((item, index) => (
                                <div className="mb-4" key={index}>
                                    <div className="fs-6 fw-bold mb-2">🏢 {item?.floor}</div>
                                    <div className="d-flex flex-wrap gap-3">
                                        {item?.cabins?.map((cabin, index) => (
                                            <div className="card-container p-3" key={index} style={{ width: "22%" }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="fs-5  ">{cabin?.name}</div>
                                                    {cabinData?.[cabin?.cabin_id]?.is_available ?
                                                        <div className="d-flex gap-2 align-items-center text-success">
                                                            <div className="bg-success rounded" style={{ width: "12px", height: "12px" }}></div>
                                                            <span>Available</span>
                                                        </div> :
                                                        <div className="d-flex gap-2 align-items-center text-danger">
                                                            <div className="bg-danger rounded" style={{ width: "12px", height: "12px" }}></div>
                                                            <span>Occupied</span>
                                                        </div>
                                                    }
                                                </div>
                                                <div style={{ color: "grey" }} className="mb-1">
                                                    {!cabinData?.[cabin?.cabin_id]?.next_time ?
                                                        <div>Free all day</div> :
                                                        <div>{cabinData?.[cabin?.cabin_id]?.is_available ? "Available Till: " : "Available After: "}{cabinData?.[cabin?.cabin_id]?.next_time}</div>
                                                    }
                                                </div>
                                                <div>
                                                    <button className="w100 rounded button btn-primary" onClick={() => { handleBookNow(cabin) }}>Book Now</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )))}
                    </div> :
                    <CabinBookingCalendar cabinList={cabinList} callApi={callApi} />
                }
                <Dialog visible={showBooking} onHide={() => setShowBooking(false)} draggable={false} className="modal-large" header={`Book ${bookCabinInfo?.name}`}>
                    <CabinBookingForm shiftTime={shiftTime} selectedCabin={bookCabinInfo} selectedDate={new Date()} closePopup={() => setShowBooking(false)} callApi={() => getCabinBookingDetails()} displaySlot={displaySlot} />
                </Dialog>
            </div>
        </div>
    )
}

export default CabinBooking